export const FullstackeData = [
  {
    title: "Scenerio Based Problems",
    subtitle: "based on scenerio solve each topic",
    filepath: "/Finance/app.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Scenerio Based system design",
    subtitle: "based on scenerio solve each topic",
    filepath: "/fullstack/datadog.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Plan Overall",
    subtitle: "all scenerios implemented as one ",
    filepath: "/fullstack/planoa.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "API -TESTING ",
    subtitle: "P95,P99",
    filepath: "/fullstack/apitesting.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "redis",
    subtitle: "redis kya hai",
    filepath: "/fullstack/redis.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Essential design concepts ",
    subtitle: "CDN,PUB SUB  kya hai",
    filepath: "/fullstack/design.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Redis- backend ",
    subtitle: "using redis in an app",
    filepath: "/fullstack/redis-ba.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "HTML Overview",
    subtitle: "Hyper Text Markup Lnaguage",
    filepath: "/fullstack/html.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Document in webrowser",
    subtitle: "Document",
    filepath: "/fullstack/document.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
  {
    title: "Javascript",
    subtitle: "ALL JS",
    filepath: "/fullstack/js.md",
    content:
      "Before starting with the Spring Framework, you should have a good understanding of Java, object-oriented programming concepts, and basic knowledge of web technologies such as HTML and HTTP.",
  },
];
